/* eslint-disable */
import React, {
  KeyboardEvent,
  memo,
  RefObject,
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";
import styles from "./VideoCommentPanel.module.css";
import {useFormTextInput} from "../../../../common/useFormTextInput";
import Button from "../../../../common/components/button/Button";
import {useDispatch, useSelector} from "react-redux";
import {createVideoComment} from "../../../../common/video/VideoActions";
import CommentCard from "./comment/CommentCard";
import {VideoComment} from "../../../../common/video/models/VideoComment";
import CommentIcon from "../../../../common/components/icons/CommentIcon";
import {AppState} from "../../../../root/RootReducer";
import PuiTypography from "../../../../components/elements/PuiTypography";
import useResponsive from "../../../../common/useResponsive";

interface VideoCommentPanelProps {
    videoId: number;
    comments: VideoComment[];
    videoRef: RefObject<HTMLVideoElement>;
}
// function coverComments(comments:VideoComment[]) {
//   return comments?.map((comment) => {
//     return comment
//   })
// }
function VideoCommentPanel({comments, videoId, videoRef}: VideoCommentPanelProps) {

    const dispatch = useDispatch();
    const { isMobile } = useResponsive();

    const [input, updateInput, resetInput] = useFormTextInput();

    const {userInfo} = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo
   }));

    const [currentComments, setCurrentComments] = useState<VideoComment[]>(comments);

  useEffect(() => {
    setCurrentComments(comments)
  }, [comments]);

    const submitComment = useCallback(() => {
        if (videoRef && videoRef.current) {
            const commentTimeMillis = Math.floor(videoRef.current.currentTime * 1000);
            dispatch(createVideoComment({
                id: videoId,
                userId: userInfo ? parseInt(userInfo.id) : 1,
                text: input.trim(),
                commentTimeMillis: commentTimeMillis,
                isPrivate: true
           }));
            resetInput();

            let newComment: VideoComment = {
                id: `_temp_id_${new Date().getTime()}` ,
                videoId: videoId,
                userId: userInfo?.id,
                fullName: "",
                text: input.trim(),
                commentTimeMillis: commentTimeMillis,
                created: new Date()
           };

            setCurrentComments((pre) => {
              return [newComment,...pre];
            });
       }
   }, [dispatch, videoId, input, resetInput, videoRef, userInfo, currentComments]);

    const isValidInput = useMemo(() => Boolean(input.trim()), [input]);

    const handleEnterKey = useCallback((event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter" && isValidInput) {
            submitComment();
       }
   }, [submitComment, isValidInput]);

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <span className={styles.headerIcon}>
                    <CommentIcon size={isMobile ? 16 : 20}/>
                </span>

                <PuiTypography size={isMobile ? 16 : 20} bold={true}>Comments</PuiTypography>
                <div style={{marginLeft: "16px"}}>
                    <PuiTypography size={isMobile ? 16 : 20}>{String(currentComments.length)}</PuiTypography>
                </div>
            </div>

            <div className={styles.input}>
                <div className={styles.inputLeft}>
                    <input
                        type="text"
                        value={input}
                        onChange={updateInput}
                        onKeyPress={handleEnterKey}
                        placeholder="Leave a comment..."
                    />
                </div>
                <div className={styles.inputRight}>
                    <Button
                        onClick={submitComment}
                        disabled={!isValidInput}
                        color="white"
                    >
                        Comment
                    </Button>
                </div>
            </div>

            <div className={styles.comments}>
                {currentComments.map((comment, index) => (
                    <CommentCard
                        key={index}
                        comment={comment}
                        videoRef={videoRef}
                    />
                ))}
            </div>
        </div>
    );
}


export default memo(VideoCommentPanel);
